<template>
  <v-sheet class="secondary pa-3">
    <v-row class="text-center">
      <v-col cols="6" class="mx-auto pb-1">
        <v-btn
          text
          small
          @click="section = 'latest_comments'"
          :class="section == 'latest_comments' ? 'accent--text ' : ''"
        >
          Latest Comments
        </v-btn>
      </v-col>
      <v-col cols="6" class="mx-auto pb-1">
        <v-btn
          text
          small
          @click="section = 'top_users'"
          :class="section == 'top_users' ? 'accent--text ' : ''"
        >
          Top Users
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      class="pa-1 text-left"
      :style="{ maxHeight: $vuetify.breakpoint.xs ? '260px' : '' }"
    >
      <v-col cols="12" class="pt-0" v-show="section == 'latest_comments'">
        <LatestComments />
      </v-col>
      <v-col cols="12" class="pt-0" v-show="section == 'top_users'">
        <ListTopUsers />
      </v-col>
    </v-row>
  </v-sheet>
</template>
<script>
import SendRequestMixin from "../../mixins/SendRequestMixin";

export default {
  name: "WidgetUsers",
  mixins: [SendRequestMixin],
  components: {
    ListTopUsers: () => import("../ListTopUsers.vue"),
    LatestComments: () => import("./LatestComments.vue")
  },
  data() {
    return {
      section: "latest_comments"
    };
  }
};
</script>
